import { useClassNames } from "@metaforcelabs/metaforce-core"
import GenericModal from "../../../components/Modals/genericModal"
import { useEffect, useState } from "react";
import { createGroup, updateGroup, updateText } from "../../../api/textlibrary";
import toast from "react-hot-toast";

export default function EditGroupDialog({ open, group, groups, onConfirm }) {
    const { classNames } = useClassNames();
    const [error, setError] = useState();
    const [name, setName] = useState("");

    useEffect(() => {
        if (open) {
            setName(group.name);
            setError(undefined);
        }
    }, [open])

    const handleChange = (e) => {
        setName(e.target.value);
    }

    const handleConfirm = async (confirm) => {
        if (confirm) {
            if (!name) {
                setError("Required");
                return;
            } else if (groups.find(g => g.name === name && g.id !== group.id)) {
                setError("Already exists");
                return;
            }

            try {
                if (group.id) {
                    await updateGroup({
                        ...group,
                        name: name,
                    });
                } else {
                    await createGroup({
                        name: name
                    });
                }

            } catch (err) {
                if (err.response?.status === 400 && err.response?.data?.Message?.startsWith("TextLibraryErrors:")) {
                    const message = err.response?.data?.Message.replace("TextLibraryErrors:", "");
                    toast.error(message);
                } else {
                    toast.error("Failed to save group");
                }
                return;
            }
        }

        onConfirm(confirm);
    }

    return (
        <GenericModal
            open={open}
            onClose={() => handleConfirm(false)}
            onConfirm={() => handleConfirm(true)}
            onCancel={() => handleConfirm(false)}
            confirmButtonText={"OK"}
            cancelButtonText={"Cancel"}
            showCancelButton={true}
        >
            <div className="">
                <h3 className="text-left text-lg font-medium py-2" >{group?.id ? 'Edit' : 'Create'} group</h3>
                <hr></hr>
                <div className="py-5">
                    <div className="mt-1 relative rounded-md w-full text-left">
                        <label htmlFor="name" className="block text-sm font-medium text-gray-700 ">Name</label>
                        <input
                            id="name"
                            type={"text"}
                            name="name"
                            value={name}
                            className={classNames(`focus:ring-gray-400 focus:border-gray-400 block sm:text-sm rounded-md w-full`,
                                error ? "border-red-500" : "border-gray-300"
                            )}
                            onChange={handleChange}
                        />
                        {error ? (
                            <div className="text-red-500">{error}</div>
                        ) : null}
                    </div>
                </div>
            </div>
        </GenericModal>
    )
}